// extracted by mini-css-extract-plugin
module.exports = {"searchPane":"SearchPane_searchPane__26WUY"};